<template>
  <div class="d-inline">
    <button type="button" :class="btnClass" data-toggle="modal" :data-target="`#${modalID}`">
      <slot> <i class="flaticon2-download"></i> Download </slot>
    </button>

    <div class="modal fade" :id="modalID" data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="la la-download"></i>
              Download Output Files
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="list-group">
              <div v-for="(file, index) in order.output" :key="index">
                <a :href="file.path" class="border-0 d-flex align-items-center justify-content-between list-group-item list-group-item-action" target="_blank">
                  <span>{{ file.name }}</span>
                  <span class="la la-download"></span>
                </a>
                <div v-if="index + 1 !== order.output.length" class="dropdown-divider"></div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
    btnClass: {
      type: String,
      default: "btn btn-success btn-sm btn-upper",
    },
  },

  computed: {
    modalID() {
      return `download-file-modal-${this.order.id}`;
    },
  },
};
</script>
